import React from 'react';
import { makeStyles, Box } from '@material-ui/core';
import PaginationControl, { PaginationControlProps } from './PaginationControl';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        // color: theme.custom.palette.label,
        // fontSize: theme.custom.typography.base.fontSize['14'],
        lineHeight: 1,
        // fontWeight: theme.custom.typography.base.fontWeight.normal,
        // letterSpacing: theme.custom.typography.base.letterSpacing.medium,
        // fontFamily: theme.custom.typography.base.fontFamily,
        [theme.breakpoints.down('xs')]: {
            // fontSize: theme.custom.typography.base.fontSize['12'],
            flexDirection: 'column',
        },
        margin: theme.spacing(-0.5),
    },
    controlWithLabels: {
        display: 'flex',
        alignItems: 'center',
        margin: theme.spacing(0.5),
    },
}));

interface Props extends PaginationControlProps {
    showingFromItem: number;
    showingToItem: number;
    itemsCount: number;
}

const Pagination: React.FC<Props> = (props) => {
    const { pageCount, showingFromItem, showingToItem, itemsCount } = props;
    const classes = useStyles();
    if (pageCount <= 1) {
        return null;
    }
    return (
        <div className={classes.root}>
            <Box m={0.5}>
                {showingFromItem}. – {showingToItem}. items from {itemsCount}
            </Box>
            <div className={classes.controlWithLabels}>
                Page
                <PaginationControl {...props} />
                from {pageCount}
            </div>
        </div>
    );
};

export default Pagination;
